import { MenuItem, SxProps, TextField } from "@mui/material";
import { formatTime, parseTime } from "@notemeal/shared/ui/utils/dateTimes";
import { addMinutes, getMinutes } from "date-fns";
import React from "react";
import { useMenusStyles } from "../styles";

const UNDER_HOUR_DURATION_OPTIONS = [15, 30, 45];
const MAX_HOURS = 12;

interface MenuDurationSelectProps {
  value: number;
  startTime: string;
  onChange: (value: number) => void;
  sx?: SxProps;
}

const MenuDurationSelect = ({ value, onChange, startTime, sx }: MenuDurationSelectProps) => {
  const menuClasses = useMenusStyles();
  const startDateTime = parseTime(startTime);

  let DURATION_OPTIONS = UNDER_HOUR_DURATION_OPTIONS.concat(
    // add options for every 1 hour and every half hour for 12 hours after start time
    Array.from({ length: MAX_HOURS }, (_, i) => (i + 1) * 60),
    Array.from({ length: MAX_HOURS }, (_, i) => (i + 1) * 60 + 15),
    Array.from({ length: MAX_HOURS }, (_, i) => (i + 1) * 60 + 30),
    Array.from({ length: MAX_HOURS }, (_, i) => (i + 1) * 60 + 45)
  );

  const curEndtime = getMinutes(startDateTime) + value;
  if (DURATION_OPTIONS.indexOf(curEndtime) === -1) {
    DURATION_OPTIONS.push(curEndtime);
  }

  DURATION_OPTIONS = DURATION_OPTIONS.sort((a, b) => a - b);

  return (
    <>
      <TextField
        select
        label="End"
        margin="dense"
        value={value}
        sx={sx}
        onChange={e => onChange(parseInt(e.target.value))}
        SelectProps={{
          classes: {
            select: menuClasses.selectRoot,
          },
          MenuProps: { sx: { maxHeight: "calc(100vh - 300px)" } },
        }}
      >
        {DURATION_OPTIONS.map(dur => {
          return (
            <MenuItem key={dur} value={dur}>
              {formatTime(addMinutes(startDateTime, dur), {
                alwaysShowMinutes: true,
              })}
            </MenuItem>
          );
        })}
      </TextField>
    </>
  );
};

export default MenuDurationSelect;
